export default __webpack_public_path__ + "3e58054634ea2b2339e526232e7d6cd7.svg";